import { Component, Injector, OnInit } from '@angular/core';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { ManagePairingService } from 'src/app/services/manage-pairing.service';
import { UtilsService } from 'src/app/services/utils.service';
import { UntypedFormControl, Validators } from '@angular/forms';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { SuccessComponent } from '../success/success.component';
import { AlertConfirmPopupComponent } from 'src/app/common/alert-confirm-popup';
import { COMMON_CONSTANTS, MANAGE_LINE_CONST, MANAGE_PAIRING } from 'src/app/common/core/common.constants';
import { LoaderService } from 'src/app/services/loader.service';
import { isNullOrUndefined } from 'src/app/services/utils';
import { HelperUtilityService } from 'src/app/services/helper-utility.service';

@Component({
  selector: 'app-manage-pairing',
  templateUrl: './manage-pairing.component.html',
  styleUrls: ['./manage-pairing.component.scss']
})
export class ManagePairingComponent implements OnInit {

  authoringContentData: any;
  disablePair: boolean;
  disableUnpair: boolean;
  enableSubmitButton: boolean;
  selectedLine: any;
  ban: string;
  gsmLineLabel: string;
  digitLineLabel: string;
  banMsisdnSet: any;

  radioOptionSelected = new UntypedFormControl('', [Validators.required]);
  gsmLineFormControl = new UntypedFormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern("^[0-9]*$")])
  digitsLineFormControl = new UntypedFormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern("^[0-9]*$")])

  mngPairingSvc: ManagePairingService;
  utilsSvc: UtilsService;
  modalService: NgbModal;
  manageLineService: ManageLineService;
  ngbModalOptions: NgbModalOptions;
  loaderSvc: LoaderService;
  helperUtilSvc: HelperUtilityService

  constructor(private injector: Injector) {
    this.mngPairingSvc = this.injector.get<ManagePairingService>(ManagePairingService);
    this.utilsSvc = this.injector.get<UtilsService>(UtilsService);
    this.manageLineService = this.injector.get<ManageLineService>(ManageLineService);
    this.modalService = this.injector.get<NgbModal>(NgbModal);
    this.loaderSvc = this.injector.get<LoaderService>(LoaderService);
    this.helperUtilSvc = this.injector.get<HelperUtilityService>(HelperUtilityService);
  }

  ngOnInit(): void {
    this.authoringContentData = this.utilsSvc.getContentDataFromSession();
    this.templateInit();
  }

  templateInit() {
    this.enableSubmitButton = false;

    const digitsLine = this.mngPairingSvc.isDIGITsLine(this.selectedLine?.lineType);
    const gsmLine = this.mngPairingSvc.isGSMLine(this.selectedLine?.productType);

    if (!digitsLine && !gsmLine) {
      this.modalService.dismissAll();
      this.openErrorModal(
        this.authoringContentData.managePairing.invalidLineTypeTitle,
        this.authoringContentData.managePairing.invalidLineTypeBody
      );
      return;
    }

    if (digitsLine) {
      this.digitsLineFormControl.setValue(this.selectedLine?.msisdn);
      this.digitsLineFormControl.disable();

    } else if (gsmLine) {
      this.gsmLineFormControl.setValue(this.selectedLine?.msisdn);
      this.gsmLineFormControl.disable();
    }

    this.getLinePairStatus();
  }

  getLinePairStatus() {
    const request = {
      "billingAccount": this.ban,
      "mobileNumbers": [this.selectedLine?.msisdn]
    };

    this.loaderSvc.start();
    this.mngPairingSvc.getPairingStatus(request).subscribe((response) =>{
      this.loaderSvc.stop();
      this.setInputFields(response);
      this.setInputLineLabels();
    },(error) => {
      this.manageLineService.close();
      this.openErrorModal(COMMON_CONSTANTS.ALERT_TYPES.WARNING, COMMON_CONSTANTS.SERVER_ERROR_MSG);
    });
  }

  setInputFields(managePairingStatusResp) {
      // 1 GSM to Many DIGITs
      // 1 DIGITs to 1 GSM
      if (managePairingStatusResp[0]?.paired) {
        // If line is DIGITs and PAIRED, only option allowed is to unpair
        if (this.mngPairingSvc.isDIGITsLine(this.selectedLine?.lineType)) {
          this.disablePair = true;
          this.radioOptionSelected.setValue(MANAGE_PAIRING.UNPAIR);
          this.gsmLineFormControl.setValue(managePairingStatusResp[0]?.pairedDetails[0]?.mobileNumber);
          this.gsmLineFormControl.disable();

          // In this scenario we are setting paired voice line and
          // setting only option available, meaning user is not submitting
          // any input - therefore no eligibilty call needed. Simply enable
          // submitt button
          this.enableSubmitButton = true;

        } else {
          // Default option should be paired when option is available based on
          // pairing logic 
          this.radioOptionSelected.setValue(MANAGE_PAIRING.PAIR);
        }
      } else {
        // If line is not paired, not able to unpair
        this.disableUnpair = true;
        this.radioOptionSelected.setValue(MANAGE_PAIRING.PAIR);
      }
  }

  setInputLineLabels() {
    const labels = this.mngPairingSvc.getFormLineLabels(this.radioOptionSelected?.value, this.selectedLine?.lineType, this.selectedLine?.productType);

    this.digitLineLabel = labels.digitLineLabel;
    this.gsmLineLabel = labels.gsmLineLabel;
  }

  onInputEligibilityCheck() {
    const invalidLines = this.gsmLineFormControl.invalid || this.digitsLineFormControl.invalid;
    const actionNotSelected = this.radioOptionSelected.value?.trim() === "";

    if (invalidLines || actionNotSelected) {
      return;
    }

    if (!this.banMsisdnSet.has(this.gsmLineFormControl.value) || !this.banMsisdnSet.has(this.digitsLineFormControl.value)) {
        this.openErrorModal(this.authoringContentData.managePairing.eligiblityFailedTitle, this.authoringContentData.managePairing.msisdnNotUnderBAN);
    } else {
      this.checkEligibility();
    }
  }

  checkEligibility() {
    const body = {
      "gsmLine": this.gsmLineFormControl.value,
      "digitsLine": this.digitsLineFormControl.value,
      "billingAccount": this.ban,
      "action": this.radioOptionSelected.value
    };

    this.loaderSvc.start();
    this.mngPairingSvc.checkEligibility(body).subscribe((response) => {
      this.loaderSvc.stop();
      if (response?.eligible) {
        this.enableSubmitButton = true;
      } else {
        this.enableSubmitButton = false;
        this.openErrorModal(this.authoringContentData.managePairing.eligiblityFailedTitle, response?.errorMsg);
      }
    }, (error) => {
      this.manageLineService.close();
      this.openErrorModal(COMMON_CONSTANTS.ALERT_TYPES.WARNING, COMMON_CONSTANTS.SERVER_ERROR_MSG);
    });
  }

  submitChange() {
    const authInfo = JSON.parse(sessionStorage.getItem(MANAGE_LINE_CONST.AUTHENTICATION_INFO));

    const body = {
      "gsmLine": this.gsmLineFormControl.value,
      "digitsLine": this.digitsLineFormControl.value,
      "billingAccount": this.ban,
      "action": this.radioOptionSelected.value,
      "orgId": this.helperUtilSvc.getOrgID(),
      "logonId": !isNullOrUndefined(authInfo) ? authInfo.logonID : COMMON_CONSTANTS.LOGON_ID,
      "email": !isNullOrUndefined(authInfo) ? authInfo.logonEmail : COMMON_CONSTANTS.LOGON_ID
    };

    this.loaderSvc.start();
    this.mngPairingSvc.submitManagePairRequest(body).subscribe((response) => {
      this.loaderSvc.stop();
      if (response?.status === MANAGE_LINE_CONST.SUCCESS) {
        this.openSuccessModal(response?.transId);
      } else {
        this.openErrorModal(this.authoringContentData.managePairing.submitFailedHeader, response?.errorMsg);
      }
    }, (error) => {
      this.manageLineService.close();
      this.openErrorModal(COMMON_CONSTANTS.ALERT_TYPES.WARNING, COMMON_CONSTANTS.SERVER_ERROR_MSG);
    });
  }

  openSuccessModal(transactionId) {
    this.ngbModalOptions = {
      backdrop: "static",
      keyboard: false,
      centered: false,
      container: "#am-container-custom",
    };
    const ref = this.modalService.open(SuccessComponent, this.ngbModalOptions);
    ref.componentInstance.header = this.authoringContentData.managePairing.submitSuccessHeader;
    ref.componentInstance.modalBodyContent = this.authoringContentData.managePairing.submitSuccessBody + transactionId;
    ref.componentInstance.isConfirmationPopup = false;
  }

  openErrorModal(title, errorMsg) {
    this.ngbModalOptions = {
      backdrop: "static",
      keyboard: false,
      centered: false,
      container: "#am-container-custom",
    };
    const ref = this.modalService.open(AlertConfirmPopupComponent, this.ngbModalOptions);
    ref.componentInstance.title = title;
    ref.componentInstance.message = errorMsg;
    ref.componentInstance.btnOkText = COMMON_CONSTANTS.OK;
  }
}
